'use strict';

/**
 * Validates an Israeli ID number using the Luhn algorithm.
 * Input is padded to 9 digits with leading zeros if needed.
 * @param {string|number} id - The ID value to validate
 * @returns {boolean} - True if valid
 */
function validateIsraeliID(id) {
    var idString = String(id).trim();
    if (!/^\d+$/.test(idString) || idString.length > 9) return false;
    var fullId = idString.padStart(9, '0');
    var totalSum = Array.from(fullId).reduce(function (acc, digit, i) {
        var weight = (i % 2 === 0) ? 1 : 2;
        var step = parseInt(digit, 10) * weight;
        step = step > 9 ? step - 9 : step;
        return acc + step;
    }, 0);
    return totalSum % 10 === 0;
}

/**
 * Applies or clears Luhn validation error state on an ID input field.
 * Only activates when field value is exactly 9 digits (HTML5 handles all other cases).
 * Reads the error message from the field's data-range-error attribute.
 * @param {jQuery} $field - The jQuery-wrapped input element
 * @returns {boolean} - True if field is valid (or not yet 9 digits)
 */
function applyLuhnValidation($field) {
    var value = $field.val();
    if (!value || !/^\d{9}$/.test(value)) {
        return true; // defer to HTML5 for empty/wrong-format
    }
    if (!validateIsraeliID(value)) {
        $field.addClass('is-invalid');
        $field.closest('.form-group').addClass('is-invalid');
        $field.parents('.form-group').find('.invalid-feedback')
            .text($field.data('range-error'));
        return false;
    }
    // Valid — clear Luhn error state so it doesn't persist after correction
    $field.removeClass('is-invalid');
    $field.closest('.form-group').removeClass('is-invalid');
    $field.parents('.form-group').find('.invalid-feedback').text('');
    return true;
}

module.exports = { validateIsraeliID: validateIsraeliID, applyLuhnValidation: applyLuhnValidation };
